import { useCallback } from 'react';
import { useStore } from 'react-admin';
import type { PinMap } from './types';

/* Persists per-user UI preferences in RA store (defaults to localStorage) */
const usePinnedFields = (pinScope: string) => {
  const storeKey = `candidate:pins:${pinScope}`;

  const [pins, setPins] = useStore<PinMap>(storeKey, {});

  const isPinned = useCallback((fieldKey: string) => !!pins[fieldKey], [pins]);

  const togglePin = useCallback(
    (fieldKey: string) => {
      setPins((prev) => {
        const next = { ...(prev ?? {}) };
        if (next[fieldKey]) delete next[fieldKey];
        else next[fieldKey] = true;
        return next;
      });
    },
    [setPins]
  );

  const clearPins = useCallback(() => setPins({}), [setPins]);

  return { pins: pins ?? {}, isPinned, togglePin, clearPins };
};

export default usePinnedFields;
